import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { USBButton } from '@usb-shield/forms-beta';

import {
    USBIconMail,
    USBIconChevronRight,
} from '@usb-shield/react-icons';

import USBLink from '@usb-shield/react-link';

import styles from './SendEmail.module.scss';

import defaultLang from '../../language';

import EmailStatusModal from './EmailStatusModal/EmailStatusModal';

import useEnv from '../../hooks/useEnv';

import {
    initiateQuestionnaireDynamicLanding,
    resetSelection,
    updateVisibleQuestions,
    reviewSelection,
    navigationToFirstQuestion,
} from '../../redux/actions';

import { productConfiguration } from '../../config';

import { getVisibleQuestions } from '../../utils/dynamicDpsUtils';

function SendEmail({
    reportingDataOnClickEvent,
    onReportingDataResultsHandler,
}) {
    const dispatch = useDispatch();

    const { env } = useEnv();

    const [emailPayload, setEmailPayload] = useState({});

    const [showModal, setShowModal] = useState(false);
    const filteredResults = useSelector(
        (state) => state.recommendationReducer.filteredResults,
    );
    const relationshipName = useSelector(
        (state) => state.dynamicLandingReducer.relationshipName,
    );

    const answerContainer = useSelector(
        (state) => state.appReducer.answerContainer,
    );

    const userDetails = useSelector(
        (state) => state.appReducer.userDetails,
    );

    const getUpdatedCategorisedList = (products) => {
        const categoriesList = [];

        products.forEach((individualProduct) => {
            categoriesList.push(
                individualProduct.productCategoryName,
            );
        });

        const finalCategorisedList = [...new Set(categoriesList)].map(
            (individualCategory) => ({
                productCategoryName: individualCategory,

                productName: [],
            }),
        );

        products.forEach((individualProduct) => {
            finalCategorisedList.forEach(
                (individualCategoriesProduct) => {
                    if (
                        individualProduct.productCategoryName ===
                        individualCategoriesProduct.productCategoryName
                    ) {
                        individualCategoriesProduct.productName.push(
                            ...individualProduct.productName,
                        );
                    }
                },
            );
        });

        return finalCategorisedList;
    };
    const getProductList = () => {
        const updatedProductList = [];
        filteredResults.forEach((product) => {
            const productName = product.name;
            const updatedName = productName

                .replaceAll('<sup>', '')

                .replaceAll('</sup>', '');

            const productObject = {
                productCategoryName: product.productCategory,

                productName: [
                    {
                        name: updatedName,

                        pickedForYouContent:
                            product.pickedForYouContent,
                    },
                ],
            };

            updatedProductList.push(productObject);
        });

        const finalCategoristProductsList = getUpdatedCategorisedList(
            updatedProductList,
        );

        return finalCategoristProductsList;
    };

    const sendEmail = () => {
        reportingDataOnClickEvent(defaultLang.siteCat.emailLink);
        const regex = /\.email$|\.test$/i;
        const emailChange = userDetails.email.replace(regex, '.com');
        const productsList = getProductList();
        const payload = {
            bankerFirstName: userDetails.givenName,
            relationshipName,

            toEmail:
                env === 'it' || env === 'uat'
                    ? emailChange
                    : userDetails.email,

            productCategory: productsList,
        };

        setEmailPayload(payload);

        setShowModal(true);
    };

    const closeEmailStatusModal = (modalFlag) => {
        setShowModal(modalFlag);

        setEmailPayload({});
    };

    const initiateStartOver = () => {
        reportingDataOnClickEvent(
            defaultLang.siteCat.changeAnswersSecondLink,
        );
        dispatch(navigationToFirstQuestion());

        dispatch(
            initiateQuestionnaireDynamicLanding(
                productConfiguration['dynamic-business-banking'],
            ),
        );

        dispatch(resetSelection());
    };

    const reviewAndEditSelection = () => {
        reportingDataOnClickEvent(
            defaultLang.siteCat.changeAnswersFirstLink,
        );
        dispatch(navigationToFirstQuestion());

        dispatch(
            initiateQuestionnaireDynamicLanding(
                productConfiguration['dynamic-business-banking'],
            ),
        );

        const visibleQuestions = getVisibleQuestions(answerContainer);

        dispatch(reviewSelection(visibleQuestions));

        dispatch(updateVisibleQuestions(visibleQuestions));
    };

    return (
        <>
            <div className={styles['sendemail-container']}>
                <div className={styles['sendemail-header']}>
                    {defaultLang.recommendation.sendEmailHeader}
                </div>

                <div className={styles['sendemail-content']}>
                    {defaultLang.recommendation.sendEmailContent}
                </div>

                <USBButton
                    variant="secondary"
                    ariaLabel="send email"
                    id="send-email"
                    onSubmit={sendEmail}
                >
                    <div className={styles['icon-text-wrapper']}>
                        <USBIconMail />

                        {
                            defaultLang.recommendation
                                .sendEmailButtonLabel
                        }
                    </div>
                </USBButton>

                <div className={styles['change-header']}>
                    {defaultLang.recommendation.changeHeader}
                </div>

                <div className={styles['change-content']}>
                    {defaultLang.recommendation.changeAnswerContent}
                </div>

                <div className={styles['answer-link']}>
                    <USBLink
                        id="edit-existing-answers"
                        href="#"
                        handleClick={reviewAndEditSelection}
                        ariaProps={{
                            label: `Edit existing answers`,
                        }}
                    >
                        {
                            defaultLang.recommendation
                                .editExistingAnswer
                        }
                        <span className={styles['icon-right']}>
                            <USBIconChevronRight />
                        </span>
                    </USBLink>
                </div>

                <div className={styles['answer-link']}>
                    <USBLink
                        id="provide-all-answer"
                        href="#"
                        linkType="basic"
                        handleClick={initiateStartOver}
                        ariaProps={{
                            label: `Provide all new answers`,
                        }}
                    >
                        {defaultLang.recommendation.provideAllAnswer}

                        <span className={styles['icon-right']}>
                            <USBIconChevronRight />
                        </span>
                    </USBLink>
                </div>
            </div>

            <EmailStatusModal
                onReportingDataResultsHandler={
                    onReportingDataResultsHandler
                }
                isOpen={showModal}
                closeModal={(modalFlag) =>
                    closeEmailStatusModal(modalFlag)
                }
                emailPayload={emailPayload}
                dataflag
            />
        </>
    );
}

export default SendEmail;
